import { useTranslations } from 'next-intl';
import { EnumPriceUnit, Option, EnumOptionKind } from 'src/types';

const DisplayPriceUnit: React.FC<{
  option: Option;
  priceUnit?: string;
}> = ({ option, priceUnit }) => {
  const translation = useTranslations('components.DisplayPriceUnit');
  return priceUnit
    ? priceUnit
    : option.kind === EnumOptionKind.stay
    ? `/${translation('night')}`
    : option.kind === EnumOptionKind.flexibleAdventure
    ? `/${translation('day')}`
    : option.priceUnit === EnumPriceUnit.perGroup
    ? `/${translation('group')}`
    : option.priceUnit === EnumPriceUnit.perRoom
    ? `/${translation('room')}`
    : `/${translation('person')}`;
};

export default DisplayPriceUnit;
